import BaseSetup from '@/components/BaseSetup';
import useColorService from '@/services/ColorService';
import { useDigitalSafeDocumentTempWorkerService } from '@/services/digital-safe/DigitalSafeDocumentTempWorkerService';
import useDigitalSafeService from '@/services/digital-safe/DigitalSafeService';
import { Reactive } from '@/utils/decorators';
import { Bus } from '@orion.ui/orion';

export type SharedDigitalSafeArboLabelEmits = {};
export type SharedDigitalSafeArboLabelProps = {
	isFold?: boolean
	id: number
	parentId?: number
	color?: Orion.ColorExtendedAndGreys
	caption?: string
};

export default class SharedDigitalSafeArboLabelSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = { isFolded: false };

	get isFolded () { return this.state.isFolded }
	get children () { return this.service.getChildrenLabels(this.props.id) }
	get swapColor () { return useColorService().swapColor(this.props.color) }
	get service () { return this.self.isAgency() ? useDigitalSafeService() : useDigitalSafeDocumentTempWorkerService() }

	constructor (
		private props: SharedDigitalSafeArboLabelProps,
		private emits: SharedDigitalSafeArboLabelEmits,
		private _aside?: OrionAside,
	) {
		super();
	}

	protected onMounted () {
		this.state.isFolded = !!this.props.isFold;
	}

	toggleFold () {
		this.state.isFolded = !this.state.isFolded;

		if (this.self.isTempWorker()) {
			this.service.saveLabelFoldingAsync(this.props.id, this.state.isFolded);
		}
	}

	setActiveLabel () {
		if (this.self.isAgency()) {
			Bus.emit('DigitalSafePagedListViewSetup:updateActiveLabel', this.props.id);
		}
		else {
			this.service.activeLabelId = this.props.id;
			if (this._aside) {
				this._aside.close();
			}
		}
	}

}
